export default __webpack_public_path__ + "static/og-img-1.5M-the-ocean-cleanup-b725cf3732b5e05d902523bc3f9e4a49.png";